<template>
    <section class='create-project content box'>
        <b-tabs v-model="activeTab">

            <b-tab-item label="Overview">
                <center>
                    <h2 class='title is-4'>What can Biaggeo do for me?</h2>
                    <p>Biaggeo provides a number of tools to students to develop their projects and businesses!</p>
                    <br/>
                </center>

                <div id='feature-icons' class='columns has-text-centered'>
                    <div class='column'>
                        <b-icon icon="account-multiple" custom-class='icon-bg-blue'></b-icon><br/>
                        <span class='feature-title'>Matchmaking</span>
                        <p>Find teammates from your university to make your idea a reality</p>
                    </div>
                    <div class='column'>
                        <b-icon icon="currency-usd" custom-class='icon-bg-green'></b-icon><br/>
                        <span class='feature-title'>Crowdfunding</span>
                        <p>Raise capital from students, alumni, family, and even strangers</p>
                    </div>
                    <div class='column'>
                        <b-icon icon="bullhorn" custom-class='icon-bg-red'></b-icon><br/>
                        <span class='feature-title'>Networking</span>
                        <p>Share your progress with alumni and connect with users and customers</p>
                    </div>
                </div>

                <center>
                    <h2 class='title is-4'>What projects are suitable on Biaggeo?</h2>
                </center>
                <p>Biaggeo is a matchmaking and crowdfunding site which helps students invent, innovate, or start a business. All projects <em>must be student-led</em>, and they must produce a <em>specific end-result</em> such as a new product, app/software, business, etc. Biaggeo is not suitable for funding or networking of clubs.</p><br/>

                <div class='columns'>
                    <div class='col is-half'>
                        <center>
                            <b-icon
                                icon="check"
                                size="is-medium"
                                custom-class='has-text-success'>
                            </b-icon>
                        </center>

                        <p>The Rocket Club has an ambitious plan to build and launch a liquid-fuel rocket by the end of the semester. They also plan a series of videos outlining their design process</p>
                        <div class="notification">
                            <div class="content">
                                <h3>Acceptable</h3>
                                <p>
                                    These students are inventing something and have a specific, attainable goal.
                                </p>
                            </div>
                        </div>

                        <b-collapse :open="false">
                            <p slot="trigger">Lindsey is a business student wanting to start a coffee shop on campus. She's already cleared the leasing details with the university, and now she just needs to find a few student workers and raise capital for launch <a>Toggle</a></p>
                            <div class="notification">
                                <div class="content">
                                    <h3>Acceptable</h3>
                                    <p>
                                        Lindsey is starting a business and needs help. The fact she cleared the details with her university is a big plus, but not necessarily required.
                                    </p>
                                </div>
                            </div>
                        </b-collapse>

                    </div>
                    <div class='col is-half'>
                        <center>
                            <b-icon
                                icon="close"
                                size="is-medium"
                                custom-class='has-text-danger'>
                            </b-icon>
                        </center>

                        <p>The Computer Squad club is looking for $3,000 in crowdfunds to cover their club expenses for the 2017 academic school year</p>
                        <div class="notification">
                            <div class="content">
                                <h3>Not acceptable</h3>
                                <p>
                                    The club is not looking for funds to cover a specific project. Biaggeo is not suited for covering ordinary club expenses. Instead, they could seek funding for a specific project like developing a new program or launching a student help-desk business.
                                </p>
                            </div>
                        </div>

                        <b-collapse :open="false">
                            <p slot="trigger">A group of friends wants to recruit more students to volunteer at a local animal shelter. They want to use Biaggeo to organize a weekly trip <a>Toggle</a></p>
                            <div class="notification">
                                <div class="content">
                                    <h3>Not acceptable</h3>
                                    <p>
                                        Although we love puppies, Biaggeo is not designed for meetups or organizing group events. No specific project is being done here. Instead, they could create an app, for example, seeking programmers, designers, and marketing, to help get more volunteers for this cause.
                                    </p>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </b-tab-item>

            <b-tab-item label="Project details">
                <center>
                    <h2 class='title is-4'>Tell us about your project</h2>
                    <h3 class='subtitle is-6'>You can always change these details later</h3>
                </center>

                <b-field label="Project name">
                    <b-input type="text"
                        v-model="project.name"
                        placeholder="Puppy Shelter Finder"
                        maxlength="30">
                    </b-input>
                </b-field>

                <b-field label="Pitch">
                    <b-input type="textarea"
                        v-model="project.pitch"
                        placeholder="The only app that matches puppies in a local animal shelter with the right owner based on personality."
                        maxlength="160">
                    </b-input>
                </b-field>

                <!-- <b-field label="Category">
                    <b-select placeholder="Select a category" required>
                        <option value="technology">Technology</option>
                        <option value="environment">Environment</option>
                        <option value="food">Food / beverage</option>
                        <option value="health">Health</option>
                        <option value="social">Social</option>
                        <option value="fashion">Fashion</option>
                        <option value="other">Other</option>
                    </b-select>
                </b-field> -->
            </b-tab-item>

            <b-tab-item label="Finalize">
                <center>
                    <h2 class='title is-4'>Almost there...</h2>
                    <p>You're about to create a new project on Biaggeo! Here are some final things you should know.</p>
                </center><br/>

                <center>
                    <h2 class='title is-5'>Approval</h2>
                </center>
                <p>When you submit your application to create a project, it will be hidden from public view. Your university will need to approve it for it to become visible. Generally, the university may assess the quality of the project, ensure you are truly enrolled at the institution, etc.</p><br/>

                <center>
                    <h2 class='title is-5'>Managing your project</h2>
                </center>
                <p>We'll bring you to your project page once you submit this form. You can manage your project page, which is still rather empty at this point. Here are some things you may wish to do:</p>
                <ol>
                    <li><strong>Upload a project logo</strong> - We can show you where to find a temporary logo if you don't have one yet</li>
                    <li><strong>Create team positions</strong> - If you're looking for team members, creating positions on your project will indicate what roles you'd like to be filled</li>
                    <li><strong>Write a long-form description</strong> - You'll want to provide even more details on your project. This may include a story of how you came up with the idea, what your goals are, and anything else you want to mention</li>
                </ol>

                <center>
                    <b-message v-if="creationError" type="is-danger" has-icon>
                        Something went wrong while creating your project. Please try again. If this error persists, save your information and try again tomorrow. We've logged this error and an administrator will investigate the issue.
                    </b-message>
                    <b-message v-if="!project.name && !project.pitch" type="is-warning" has-icon>
                        You cannot submit this application until the form on the previous tab has been completed.
                    </b-message>
                    <a class='button is-primary is-full-width' :class="{ 'is-loading': isCreating }" @click='createProject()' :disabled="!project.name && !project.pitch || isCreating">Create</a>
                </center>
            </b-tab-item>

        </b-tabs>
    </section>
</template>

<style>
    .create-project { font-size: 90%; }
    .create-project .col {
        padding: 0 10px;
    }
    .create-project.box {
        width: 50% !important;
        margin: auto;
    }
    .feature-title {
        font-size: 1.3em;
        letter-spacing: 0px;
    }
    #feature-icons span.icon {
        margin: 10px 0 15px 0;
    }
    #feature-icons i {
        padding: 6px 12px;
        border-size: 1px;
        border-style: solid;
        border-radius: 100%;
    }
    .icon-bg-blue { color: #40afe2; }
    .icon-bg-green { color: #1eb352; }
    .icon-bg-red { color: #ed6d64; }
</style>

<script>
export default {
  name: 'CreateProject',
  data () {
    return {
        activeTab: 0,
        isCreating: false,
        creationError: false,
        project: {
            name: '',
            pitch: ''
        }
    }
  },
  methods: {
    createProject: function() {
        if(!this.project.name && !this.project.pitch) return false;

        this.isCreating = true;
        this.creationError = null;

        this.$http.post(this.$hostname + '/project', this.project).then(function(response) {
            this.isCreating = false;
            this.creationError = false;

            if(response.status === 200) {
                // Redirect the user to their new project
                this.$router.push({ path: '/project/' + response.body.id });
            }
        }).catch(function(error) {
            this.isCreating = false;
            this.creationError = true;
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/CreateProject.vue